<template>
    <div>
        <v-btn color="primary"
                small
                flat
                outline
                class="botao-menu"
                id="DocumentosCompraDireta"
                @click="$emit('acessarDocumentosCompraDireta')">
                Documentos Compra Direta
        </v-btn>
    </div>
</template>

<script>
export default {
    name: 'AcoesDocumentosCompraDireta'
}
</script>

<style scoped lang="stylus">
    .botao-menu
        text-transform capitalize
        margin 0
</style>